import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const FINANCE_ROLES = new Set(['ADMIN', 'GERENTE']);

const AdminRoute = ({ children }) => {
  const { currentUser } = useAuth();

  if (!currentUser) return <Navigate to="/login" replace />;
  if (!FINANCE_ROLES.has(String(currentUser.role || '').toUpperCase())) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
